import {
  POST_HHG_RESET_STATUS_FAILURE as POST_RESET_STATUS_FAILURE,
  POST_HHG_RESET_STATUS_REQUEST as POST_RESET_STATUS_REQUEST,
  POST_HHG_RESET_STATUS_SUCCESS as POST_RESET_STATUS_SUCCESS
} from '../types/houseHoldGoodsTypes';

const { CALL_INTAKE_V2_API } = require('middleware/intakeV2Api');
const {
  GET_ALL_HOMESALE_RESALE_OFFER_REQUEST,
  GET_ALL_HOMESALE_RESALE_OFFER_SUCCESS,
  GET_ALL_HOMESALE_RESALE_OFFER_FAILURE,
  POST_HOMESALE_RESALE_OFFER_REQUEST,
  POST_HOMESALE_RESALE_OFFER_SUCCESS,
  POST_HOMESALE_RESALE_OFFER_FAILURE,
  UPDATE_HOMESALE_RESALE_OFFER_REQUEST,
  UPDATE_HOMESALE_RESALE_OFFER_SUCCESS,
  UPDATE_HOMESALE_RESALE_OFFER_FAILURE,
  DELETE_HOMESALE_RESALE_OFFER_REQUEST,
  DELETE_HOMESALE_RESALE_OFFER_SUCCESS,
  DELETE_HOMESALE_RESALE_OFFER_FAILURE,
  GET_INSPECTIONS_REQUEST,
  GET_INSPECTIONS_SUCCESS,
  GET_INSPECTIONS_FAILURE,
  POST_INSPECTIONS_REQUEST,
  POST_INSPECTIONS_SUCCESS,
  POST_INSPECTIONS_FAILURE,
  UPDATE_INSPECTIONS_REQUEST,
  UPDATE_INSPECTIONS_SUCCESS,
  UPDATE_INSPECTIONS_FAILURE,
  DELETE_INSPECTIONS_REQUEST,
  DELETE_INSPECTIONS_FAILURE,
  UPDATE_INSPECTIONS_STATE,
  POST_EQUITY_REQUEST,
  POST_EQUITY_SUCCESS,
  POST_EQUITY_FAILURE,
  UPDATE_EQUITY_REQUEST,
  UPDATE_EQUITY_SUCCESS,
  UPDATE_EQUITY_FAILURE,
  DELETE_EQUITY_REQUEST,
  DELETE_EQUITY_SUCCESS,
  DELETE_EQUITY_FAILURE,
  POST_TAX_REQUEST,
  POST_TAX_SUCCESS,
  POST_TAX_FAILURE,
  UPDATE_TAX_REQUEST,
  UPDATE_TAX_SUCCESS,
  UPDATE_TAX_FAILURE,
  DELETE_TAX_REQUEST,
  DELETE_TAX_SUCCESS,
  DELETE_TAX_FAILURE,
  POST_CREDIT_REQUEST,
  POST_CREDIT_SUCCESS,
  POST_CREDIT_FAILURE,
  UPDATE_CREDIT_REQUEST,
  UPDATE_CREDIT_SUCCESS,
  UPDATE_CREDIT_FAILURE,
  DELETE_CREDIT_REQUEST,
  DELETE_CREDIT_SUCCESS,
  DELETE_CREDIT_FAILURE,
  GET_APPRAISALS_REQUEST,
  GET_APPRAISALS_SUCCESS,
  GET_APPRAISALS_FAILURE,
  POST_APPRAISALS_REQUEST,
  POST_APPRAISALS_SUCCESS,
  POST_APPRAISALS_FAILURE,
  UPDATE_APPRAISALS_REQUEST,
  UPDATE_APPRAISALS_SUCCESS,
  UPDATE_APPRAISALS_FAILURE,
  GET_LISTINGS_REQUEST,
  GET_LISTINGS_SUCCESS,
  GET_LISTINGS_FAILURE,
  POST_LISTINGS_REQUEST,
  POST_LISTINGS_SUCCESS,
  POST_LISTINGS_FAILURE,
  UPDATE_LISTINGS_REQUEST,
  UPDATE_LISTINGS_SUCCESS,
  UPDATE_LISTINGS_FAILURE,
  GET_HOMESALE_INFO_REQUEST,
  GET_HOMESALE_INFO_SUCCESS,
  GET_HOMESALE_INFO_FAILURE,
  POST_HOMESALE_INFO_REQUEST,
  POST_HOMESALE_INFO_SUCCESS,
  POST_HOMESALE_INFO_FAILURE,
  UPDATE_HOMESALE_INFO_REQUEST,
  UPDATE_HOMESALE_INFO_SUCCESS,
  UPDATE_HOMESALE_INFO_FAILURE,
  UPDATE_HOMESALE_PROPERTY_INFO_REQUEST,
  UPDATE_HOMESALE_PROPERTY_INFO_SUCCESS,
  UPDATE_HOMESALE_PROPERTY_INFO_FAILURE,
  GET_SPREAD_SELECTION_FAILURE,
  GET_SPREAD_SELECTION_REQUEST,
  GET_SPREAD_SELECTION_SUCCESS,
  POST_SPREAD_SELECTION_FAILURE,
  POST_SPREAD_SELECTION_REQUEST,
  POST_SPREAD_SELECTION_SUCCESS,
  UPDATE_SPREAD_SELECTION_FAILURE,
  UPDATE_SPREAD_SELECTION_REQUEST,
  UPDATE_SPREAD_SELECTION_SUCCESS,
  GET_BUYOUT_FAILURE,
  GET_BUYOUT_REQUEST,
  GET_BUYOUT_SUCCESS,
  POST_BUYOUT_FAILURE,
  POST_BUYOUT_REQUEST,
  POST_BUYOUT_SUCCESS,
  UPDATE_BUYOUT_FAILURE,
  UPDATE_BUYOUT_REQUEST,
  UPDATE_BUYOUT_SUCCESS,
  UPDATE_HOMESALE_TITLE_DOCUMENT_REQUEST,
  UPDATE_HOMESALE_TITLE_DOCUMENT_SUCCESS,
  UPDATE_HOMESALE_TITLE_DOCUMENT_FAILURE,
  GET_HOMESALE_MORTGAGE_INFO_FAILURE,
  GET_HOMESALE_MORTGAGE_INFO_REQUEST,
  GET_HOMESALE_MORTGAGE_INFO_SUCCESS,
  POST_HOMESALE_MORTGAGE_INFO_FAILURE,
  POST_HOMESALE_MORTGAGE_INFO_REQUEST,
  POST_HOMESALE_MORTGAGE_INFO_SUCCESS,
  UPDATE_HOMESALE_MORTGAGE_INFO_FAILURE,
  UPDATE_HOMESALE_MORTGAGE_INFO_REQUEST,
  UPDATE_HOMESALE_MORTGAGE_INFO_SUCCESS,
  DELETE_HOMESALE_MORTGAGE_INFO_FAILURE,
  DELETE_HOMESALE_MORTGAGE_INFO_REQUEST,
  DELETE_HOMESALE_MORTGAGE_INFO_SUCCESS,
  GET_APPRAISALS_PREFERENCES_FAILURE,
  GET_APPRAISALS_PREFERENCES_REQUEST,
  GET_APPRAISALS_PREFERENCES_SUCCESS,
  POST_APPRAISALS_PREFERENCES_FAILURE,
  POST_APPRAISALS_PREFERENCES_REQUEST,
  POST_APPRAISALS_PREFERENCES_SUCCESS,
  UPDATE_APPRAISALS_PREFERENCES_FAILURE,
  UPDATE_APPRAISALS_PREFERENCES_REQUEST,
  UPDATE_APPRAISALS_PREFERENCES_SUCCESS,
  CREATE_EQUITY_VOUCHERS_REQUEST,
  CREATE_EQUITY_VOUCHERS_SUCCESS,
  CREATE_EQUITY_VOUCHERS_FAILURE,
  CREATE_EQUITY_VOUCHERS_REPORT_REQUEST,
  CREATE_EQUITY_VOUCHERS_REPORT_SUCCESS,
  CREATE_EQUITY_VOUCHERS_REPORT_FAILURE,
  POST_EQUITY_DETAILS_REQUEST,
  POST_EQUITY_DETAILS_SUCCESS,
  POST_EQUITY_DETAILS_FAILURE,
  UNPOST_EQUITY_VOUCHERS_REQUEST,
  UNPOST_EQUITY_VOUCHERS_SUCCESS,
  UNPOST_EQUITY_VOUCHERS_FAILURE,
  UNPOST_EQUITY_DETAILS_REQUEST,
  UNPOST_EQUITY_DETAILS_SUCCESS,
  UNPOST_EQUITY_DETAILS_FAILURE,
  CREATE_HOMESALE_DISPOSITION_REPORT_REQUEST,
  CREATE_HOMESALE_DISPOSITION_REPORT_SUCCESS,
  CREATE_HOMESALE_DISPOSITION_REPORT_FAILURE,
  GET_HOMESALE_DISPOSITION_REPORT_REQUEST,
  GET_HOMESALE_DISPOSITION_REPORT_SUCCESS,
  GET_HOMESALE_DISPOSITION_REPORT_FAILURE
} = require('../types/homesaleTypes');
const {
  DELETE_TITLE_REP_REQUEST,
  DELETE_TITLE_REP_SUCCESS,
  DELETE_TITLE_REP_FAILURE,
  UPDATE_TITLE_REP_REQUEST,
  UPDATE_TITLE_REP_SUCCESS,
  UPDATE_TITLE_REP_FAILURE,
  POST_TITLE_REP_REQUEST,
  POST_TITLE_REP_SUCCESS,
  POST_TITLE_REP_FAILURE
} = require('../types/dataManagementTypes');

export const getHomesaleResaleOffers = (authorizationId, homesaleId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_ALL_HOMESALE_RESALE_OFFER_REQUEST, GET_ALL_HOMESALE_RESALE_OFFER_SUCCESS, GET_ALL_HOMESALE_RESALE_OFFER_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authorizationId}/homesale/${homesaleId}/resale`,
      method: 'GET'
    }
  };
};

export const postHomesaleResaleOffer = (authorizationId, homesaleId, dto) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_HOMESALE_RESALE_OFFER_REQUEST, POST_HOMESALE_RESALE_OFFER_SUCCESS, POST_HOMESALE_RESALE_OFFER_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authorizationId}/homesale/${homesaleId}/resale`,
      method: 'POST',
      payload: dto
    }
  };
};

export const updateHomesaleResaleOffer = (authorizationId, homesaleId, resaleOfferId, dto) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_HOMESALE_RESALE_OFFER_REQUEST, UPDATE_HOMESALE_RESALE_OFFER_SUCCESS, UPDATE_HOMESALE_RESALE_OFFER_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authorizationId}/homesale/${homesaleId}/resale/${resaleOfferId}`,
      method: 'PUT',
      payload: dto
    }
  };
};

export const deleteHomesaleResaleOffer = (authorizationId, homesaleId, resaleOfferId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_HOMESALE_RESALE_OFFER_REQUEST, DELETE_HOMESALE_RESALE_OFFER_SUCCESS, DELETE_HOMESALE_RESALE_OFFER_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authorizationId}/homesale/${homesaleId}/resale/${resaleOfferId}`,
      method: 'DELETE'
    }
  };
};
export const deleteTitleRep = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_TITLE_REP_REQUEST, DELETE_TITLE_REP_SUCCESS, DELETE_TITLE_REP_FAILURE],
      authenticated: true,
      endpoint: `api/titleRep/${id}`,
      method: 'DELETE'
    }
  };
};
export const updateTitleRep = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_TITLE_REP_REQUEST, UPDATE_TITLE_REP_SUCCESS, UPDATE_TITLE_REP_FAILURE],
      authenticated: true,
      endpoint: 'api/titleRep',
      method: 'PUT',
      payload: values
    }
  };
};
export const postTitleRep = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_TITLE_REP_REQUEST, POST_TITLE_REP_SUCCESS, POST_TITLE_REP_FAILURE],
      authenticated: true,
      endpoint: 'api/titleRep',
      method: 'POST',
      payload: values
    }
  };
};
export const getInspections = (authId, homesaleId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_INSPECTIONS_REQUEST, GET_INSPECTIONS_SUCCESS, GET_INSPECTIONS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/homesale/${homesaleId}/inspections`,
      method: 'GET'
    }
  };
};

export const postInspection = (authId, homesaleId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_INSPECTIONS_REQUEST, POST_INSPECTIONS_SUCCESS, POST_INSPECTIONS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/homesale/${homesaleId}/inspections`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateInspection = (authId, homesaleId, inspectionId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_INSPECTIONS_REQUEST, UPDATE_INSPECTIONS_SUCCESS, UPDATE_INSPECTIONS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/homesale/${homesaleId}/inspections/${inspectionId}`,
      method: 'PUT',
      payload: values
    }
  };
};

export const deleteInspection = (authId, homesaleId, inspectionId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_INSPECTIONS_REQUEST, DELETE_INSPECTIONS_REQUEST, DELETE_INSPECTIONS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/homesale/${homesaleId}/inspections/${inspectionId}`,
      method: 'DELETE'
    }
  };
};

export const updateInspectionState = inspections => {
  return { type: UPDATE_INSPECTIONS_STATE, response: inspections };
};

/* Homesale - Equity Requests */

// export const getEquity = authId => {
//   return {
//     [CALL_INTAKE_V2_API]: {
//       types: [GET_EQUITY_REQUEST, GET_EQUITY_SUCCESS, GET_EQUITY_FAILURE],
//       authenticated: true,
//       endpoint: `api/authorizations/${authId}/equity`,
//       method: 'GET'
//     }
//   };
// };

export const postEquity = (fileId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_EQUITY_REQUEST, POST_EQUITY_SUCCESS, POST_EQUITY_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${fileId}/equity`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateEquity = (fileId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_EQUITY_REQUEST, UPDATE_EQUITY_SUCCESS, UPDATE_EQUITY_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${fileId}/equity`,
      method: 'PUT',
      payload: values
    }
  };
};

export const deleteEquity = (fileId, homesaleId, equityId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_EQUITY_REQUEST, DELETE_EQUITY_SUCCESS, DELETE_EQUITY_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${fileId}/equity/${homesaleId}/${equityId}`,
      method: 'DELETE'
    }
  };
};

// export const getTaxes = equityId => {
//   return {
//     [CALL_INTAKE_V2_API]: {
//       types: [GET_TAX_REQUEST, GET_TAX_SUCCESS, GET_TAX_FAILURE],
//       authenticated: true,
//       endpoint: `api/authorizations/${equityId}/tax`,
//       method: 'GET'
//     }
//   };
// };

export const postTax = (fileId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_TAX_REQUEST, POST_TAX_SUCCESS, POST_TAX_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${fileId}/equityTaxes`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateTax = (fileId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_TAX_REQUEST, UPDATE_TAX_SUCCESS, UPDATE_TAX_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${fileId}/equityTaxes`,
      method: 'PUT',
      payload: values
    }
  };
};

export const deleteTax = (fileId, equityId, equityTaxesId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_TAX_REQUEST, DELETE_TAX_SUCCESS, DELETE_TAX_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${fileId}/equityTaxes/${equityId}/${equityTaxesId}`,
      method: 'DELETE'
    }
  };
};

// export const getCredits = equityId => {
//   return {
//     [CALL_INTAKE_V2_API]: {
//       types: [GET_CREDIT_REQUEST, GET_CREDIT_SUCCESS, GET_CREDIT_FAILURE],
//       authenticated: true,
//       endpoint: `api/authorizations/${equityId}/credit`,
//       method: 'GET'
//     }
//   };
// };

export const postCredit = (fileId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_CREDIT_REQUEST, POST_CREDIT_SUCCESS, POST_CREDIT_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${fileId}/equityCreditCharges`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateCredit = (fileId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_CREDIT_REQUEST, UPDATE_CREDIT_SUCCESS, UPDATE_CREDIT_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${fileId}/equityCreditCharges`,
      method: 'PUT',
      payload: values
    }
  };
};

export const deleteCredit = (fileId, equityId, equityCreditChargesId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_CREDIT_REQUEST, DELETE_CREDIT_SUCCESS, DELETE_CREDIT_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${fileId}/equityCreditCharges/${equityId}/${equityCreditChargesId}`,
      method: 'DELETE'
    }
  };
};

/* Homesale - Appraisals Requests */

export const getAllAppraisals = homesaleId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_APPRAISALS_REQUEST, GET_APPRAISALS_SUCCESS, GET_APPRAISALS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${homesaleId}/homesaleAppraisals`,
      method: 'GET'
    }
  };
};

export const postAppraisal = (fileId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_APPRAISALS_REQUEST, POST_APPRAISALS_SUCCESS, POST_APPRAISALS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${fileId}/homesaleAppraisals`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateAppraisal = (fileId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_APPRAISALS_REQUEST, UPDATE_APPRAISALS_SUCCESS, UPDATE_APPRAISALS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${fileId}/homesaleAppraisals`,
      method: 'PUT',
      payload: values
    }
  };
};

/* Homesale - Spread Selection Requests */

export const getSpreadSelection = homesaleId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_SPREAD_SELECTION_REQUEST, GET_SPREAD_SELECTION_SUCCESS, GET_SPREAD_SELECTION_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${homesaleId}/spreadSelection`,
      method: 'GET'
    }
  };
};

export const postSpreadSelection = (fileId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_SPREAD_SELECTION_REQUEST, POST_SPREAD_SELECTION_SUCCESS, POST_SPREAD_SELECTION_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${fileId}/spreadSelection`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateSpreadSelection = (fileId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_SPREAD_SELECTION_REQUEST, UPDATE_SPREAD_SELECTION_SUCCESS, UPDATE_SPREAD_SELECTION_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${fileId}/spreadSelection`,
      method: 'PUT',
      payload: values
    }
  };
};
/* Homesale - Listings Requests */

export const getAllListings = authId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_LISTINGS_REQUEST, GET_LISTINGS_SUCCESS, GET_LISTINGS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/listings`,
      method: 'GET'
    }
  };
};

export const postListing = (values, authId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_LISTINGS_REQUEST, POST_LISTINGS_SUCCESS, POST_LISTINGS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/listings`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateListing = (values, authId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_LISTINGS_REQUEST, UPDATE_LISTINGS_SUCCESS, UPDATE_LISTINGS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/listings`,
      method: 'PUT',
      payload: values
    }
  };
};
/* Homesale Requests */

export const getHomesaleInfo = authId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_HOMESALE_INFO_REQUEST, GET_HOMESALE_INFO_SUCCESS, GET_HOMESALE_INFO_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authId}/homesale`,
      method: 'GET'
    }
  };
};

export const postHomesaleInfo = values => {
  const username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_HOMESALE_INFO_REQUEST, POST_HOMESALE_INFO_SUCCESS, POST_HOMESALE_INFO_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/homesale/${username}`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateHomesaleInfo = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_HOMESALE_INFO_REQUEST, UPDATE_HOMESALE_INFO_SUCCESS, UPDATE_HOMESALE_INFO_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/homesale`,
      method: 'PUT',
      payload: values
    }
  };
};

// Saves the homesale record and/or its interior features ({ homesaleInfo, interiorFeatures }, either may be null) and
// responds with the reloaded homesale.
export const updateHomesalePropertyInfo = (fileId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_HOMESALE_PROPERTY_INFO_REQUEST, UPDATE_HOMESALE_PROPERTY_INFO_SUCCESS, UPDATE_HOMESALE_PROPERTY_INFO_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${fileId}/homesale/propertyInfo`,
      method: 'PUT',
      payload: values
    }
  };
};
/* Homesale - Buyout Requests */

export const getBuyout = homesaleId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_BUYOUT_REQUEST, GET_BUYOUT_SUCCESS, GET_BUYOUT_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${homesaleId}/buyout`,
      method: 'GET'
    }
  };
};

export const postBuyout = (fileId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_BUYOUT_REQUEST, POST_BUYOUT_SUCCESS, POST_BUYOUT_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${fileId}/buyout`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateBuyout = (fileId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_BUYOUT_REQUEST, UPDATE_BUYOUT_SUCCESS, UPDATE_BUYOUT_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${fileId}/buyout`,
      method: 'PUT',
      payload: values
    }
  };
};

// Local Title card edits. Stored with Morreale's title document, so Morreale's next push replaces them.
export const updateHomesaleTitleDocument = (fileId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_HOMESALE_TITLE_DOCUMENT_REQUEST, UPDATE_HOMESALE_TITLE_DOCUMENT_SUCCESS, UPDATE_HOMESALE_TITLE_DOCUMENT_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${fileId}/homesale/titleDocument`,
      method: 'PUT',
      payload: values
    }
  };
};

export const createEquityVouchers = (fileId, homesaleId, equityId, request) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [CREATE_EQUITY_VOUCHERS_REQUEST, CREATE_EQUITY_VOUCHERS_SUCCESS, CREATE_EQUITY_VOUCHERS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${fileId}/homesale/${homesaleId}/equities/${equityId}/vouchers`,
      method: 'POST',
      payload: request
    }
  };
};

export const createEquityReport = (fileId, homesaleId, equityId, request) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [CREATE_EQUITY_VOUCHERS_REPORT_REQUEST, CREATE_EQUITY_VOUCHERS_REPORT_SUCCESS, CREATE_EQUITY_VOUCHERS_REPORT_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${fileId}/homesale/${homesaleId}/equities/${equityId}/report`,
      method: 'POST',
      payload: request,
      responseType: 'blob'
    }
  };
};

export const resetHomesaleStatus = fileId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_RESET_STATUS_REQUEST, POST_RESET_STATUS_SUCCESS, POST_RESET_STATUS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${fileId}/homesale/resetStatus`,
      method: 'PUT'
    }
  };
};

export const getHomesaleMortgageInfo = homesaleId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_HOMESALE_MORTGAGE_INFO_REQUEST, GET_HOMESALE_MORTGAGE_INFO_SUCCESS, GET_HOMESALE_MORTGAGE_INFO_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${homesaleId}/mortgages`,
      method: 'GET'
    }
  };
};

export const postHomesaleMortgageInfo = (fileId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_HOMESALE_MORTGAGE_INFO_REQUEST, POST_HOMESALE_MORTGAGE_INFO_SUCCESS, POST_HOMESALE_MORTGAGE_INFO_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${fileId}/mortgages`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateHomesaleMortgageInfo = (fileId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_HOMESALE_MORTGAGE_INFO_REQUEST, UPDATE_HOMESALE_MORTGAGE_INFO_SUCCESS, UPDATE_HOMESALE_MORTGAGE_INFO_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${fileId}/mortgages`,
      method: 'PUT',
      payload: values
    }
  };
};

export const deleteHomesaleMortgageInfo = (fileId, mortgageId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_HOMESALE_MORTGAGE_INFO_REQUEST, DELETE_HOMESALE_MORTGAGE_INFO_SUCCESS, DELETE_HOMESALE_MORTGAGE_INFO_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${fileId}/mortgages/${mortgageId}`,
      method: 'DELETE'
    }
  };
};

export const getHomesaleAppraisalPreferences = homesaleId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_APPRAISALS_PREFERENCES_REQUEST, GET_APPRAISALS_PREFERENCES_SUCCESS, GET_APPRAISALS_PREFERENCES_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${homesaleId}/appraisalPreferences`,
      method: 'GET'
    }
  };
};

export const updateAppraisalPreferences = (fileId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_APPRAISALS_PREFERENCES_REQUEST, UPDATE_APPRAISALS_PREFERENCES_SUCCESS, UPDATE_APPRAISALS_PREFERENCES_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${fileId}/appraisalPreferences`,
      method: 'PUT',
      payload: values
    }
  };
};

export const postAppraisalPreferences = (fileId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_APPRAISALS_PREFERENCES_REQUEST, POST_APPRAISALS_PREFERENCES_SUCCESS, POST_APPRAISALS_PREFERENCES_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${fileId}/appraisalPreferences`,
      method: 'POST',
      payload: values
    }
  };
};

export const postEquityDetails = (fileId, homesaleId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_EQUITY_DETAILS_REQUEST, POST_EQUITY_DETAILS_SUCCESS, POST_EQUITY_DETAILS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${fileId}/homesale/${homesaleId}/equities/postDetails`,
      method: 'POST',
      payload: {}
    }
  };
};

export const unpostEquityVouchers = (fileId, homesaleId, equityId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UNPOST_EQUITY_VOUCHERS_REQUEST, UNPOST_EQUITY_VOUCHERS_SUCCESS, UNPOST_EQUITY_VOUCHERS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${fileId}/homesale/${homesaleId}/equities/${equityId}/unpost`,
      method: 'POST',
      payload: {}
    }
  };
};

export const unpostEquityDetails = (fileId, homesaleId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UNPOST_EQUITY_DETAILS_REQUEST, UNPOST_EQUITY_DETAILS_SUCCESS, UNPOST_EQUITY_DETAILS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${fileId}/homesale/${homesaleId}/equities/unpostDetails`,
      method: 'DELETE',
      payload: {}
    }
  };
};

export const createHomesaleDispositionReport = (fileId, homesaleId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        CREATE_HOMESALE_DISPOSITION_REPORT_REQUEST,
        CREATE_HOMESALE_DISPOSITION_REPORT_SUCCESS,
        CREATE_HOMESALE_DISPOSITION_REPORT_FAILURE
      ],
      authenticated: true,
      endpoint: `api/authorizations/${fileId}/homesale/${homesaleId}/dispositionReport`,
      method: 'POST',
      payload: {},
      responseType: 'blob'
    }
  };
};

export const getHomesaleDispositionReport = (fileId, homesaleId, dispositionReportId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        GET_HOMESALE_DISPOSITION_REPORT_REQUEST,
        GET_HOMESALE_DISPOSITION_REPORT_SUCCESS,
        GET_HOMESALE_DISPOSITION_REPORT_FAILURE
      ],
      authenticated: true,
      endpoint: `api/authorizations/${fileId}/homesale/${homesaleId}/dispositionReport/${dispositionReportId}`,
      method: 'POST',
      payload: {},
      responseType: 'blob'
    }
  };
};
